/** Action types for different cases */
enum ActionTypes {
  read = "read",
  add = "add",
  update = "update",
  delete = "delete"
}
export default ActionTypes;
